import {
  EllipsisWithTooltip,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';
import { OSEnum } from '@cast/types';

import { WindowsLogoSvg } from 'assets/svg';

import {
  useCluster,
  isAKSCluster,
} from '@cast/shared-cluster-context-data-access';

type Props = { instanceType?: string; os?: OSEnum };

export const NodeInstanceTypeCell = ({ instanceType, os }: Props) => {
  const { cluster } = useCluster();
  const isAks = isAKSCluster(cluster);

  return (
    <EllipsisWithTooltip
      TypographyProps={{
        variant: 'inherit',
        width: '100%',
      }}
      TooltipProps={{
        placement: 'bottom-start',
        arrow: true,
        title: instanceType ?? '-',
      }}
    >
      {instanceType ?? '-'}
      {isAks && os === OSEnum.windows && (
        <Stack direction="row" gap={2} alignItems="center">
          <WindowsLogoSvg />
          <Typography
            color={tokens.theme.fg.structural.secondary}
            variant="P10R"
          >
            Windows
          </Typography>
        </Stack>
      )}
    </EllipsisWithTooltip>
  );
};
